// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// Notifications is neccesary to import
import '@/assets/js/notifications';
// Vuex is loaded and installed from the store
import store from '@/assets/js/store';
// Vue Router is loaded and installed from the router
import router from '@/assets/js/router';
import axios from 'axios';
import bootstrapVue from 'bootstrap-vue';
// import vueTheMask from 'vue-the-mask';
import veeValidate from 'vee-validate';
import vueClipboard from 'vue-clipboard2';
import { ValidationProvider } from 'vee-validate';
import {P2_PUB_KEY} from '@/assets/js/config';
import VueDateFns from "vue-date-fns";

import fApp from '@/f-app';

// Mixins
import setAccount from '@/mixins/set-account';
import setData from '@/mixins/set-data';
import helpers from '@/mixins/helpers';
import findRegistrationStep from '@/mixins/find-registration-step';
import tabsData from '@/mixins/tabs-data';

import posthogPlugin from "@/assets/js/plugins/posthog";

Vue.use(bootstrapVue);
Vue.use(router);
// Vue.use(vueTheMask);
Vue.use(veeValidate);
Vue.use(vueClipboard);
Vue.use(VueDateFns);
Vue.use(posthogPlugin);

let stripeKeys = {
    pk: P2_PUB_KEY,
}

Vue.prototype.$http = axios;

Vue.component('ValidationProvider', ValidationProvider);

Vue.config.productionTip = false;
// Measure runtime performance in webconsole
// Vue.config.performance = true;

/* eslint-disable no-new */
new Vue({
  router,
  store,
  mixins: [
    setAccount,
    setData,
    helpers,
    findRegistrationStep,
    tabsData,
  ],
  render: h => h(fApp),
}).$mount('#app');
